import { render, staticRenderFns } from "./SidebarModal.vue?vue&type=template&id=f72a4440&scoped=true"
import script from "./SidebarModal.vue?vue&type=script&lang=js"
export * from "./SidebarModal.vue?vue&type=script&lang=js"
import style0 from "./SidebarModal.vue?vue&type=style&index=0&id=f72a4440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72a4440",
  null
  
)

export default component.exports